import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../components/TemplateDashboard";
import TutoresSimulacrosIAContent from './components/TutoresSimulacrosIAContent';

const TutoresSimulacrosIAListado = () => {

    return (
        <>

            <TemplateDashboard>
                <TutoresSimulacrosIAContent />
            </TemplateDashboard>

        </>
    )
};

export default TutoresSimulacrosIAListado;